import { mxXmlCanvas2D, mxShape } from 'mxgraph-js';
import BasicEventVertex from '../../../HCLTreeNode/FaultTreeNode/BasicEventNode/BasicEventVertex';
import HCLCellShape from '../../HCLCellShape'; // refer to the type

class BasicEventVertexDefaultShape extends mxShape {

  paintVertexShape(c: any, x: any, y: any, w: any, h: any): void {
    const gateSize = h * 0.28;
    const radius = w * 0.28 / 2;
    const strokeWidth = 2;
    c.translate(x, y);
    c.begin();
    // draw circle
    c.ellipse(w * 0.5 - radius, h - gateSize, gateSize, gateSize);
    c.fillAndStroke();
    // draw rect
    c.roundrect(0, 0, w, h - gateSize, BasicEventVertex.SHAPE.RADIUS, BasicEventVertex.SHAPE.RADIUS);
    c.fillAndStroke();
  }

  static get typeString(): string {
    return 'BasicEventVertexDefaultShape';
  }

}

export default BasicEventVertexDefaultShape;
